import { render, staticRenderFns } from "./WorkerDetail.vue?vue&type=template&id=f33932dc&scoped=true"
import script from "./WorkerDetail.vue?vue&type=script&lang=ts"
export * from "./WorkerDetail.vue?vue&type=script&lang=ts"
import style0 from "./WorkerDetail.vue?vue&type=style&index=0&id=f33932dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f33932dc",
  null
  
)

export default component.exports